import gsap from "gsap";

export default class Vehicle {
  constructor (args) {
    this.element = document.createElement("div");
    this.element.className = "vehicle";
    this.sprite = document.createElement("div");
    this.sprite.className = "sprite";
    this.shadow = document.createElement("div");
    this.shadow.className = "shadow";

    this.stepSize = 0.042;

    const [x, y] = args.position.split(",")

    this.shadow.appendChild(args.shadow.cloneNode());
    this.sprite.appendChild(args.sprite.cloneNode());

    this.element.appendChild(this.shadow);
    this.element.appendChild(this.sprite);

    this.createLabel(args)

    gsap.set(this.element, { left: `${x}%`, top: `${y}%` });

    this.rotation = gsap.timeline({ paused: true });

    this.rotation.to(this.sprite.querySelector("img"), { xPercent: -95.83, ease: "steps(23)", duration: 2 })
    this.rotation.to(this.shadow.querySelector("img"), { xPercent: -95.83, ease: "steps(23)", duration: 2 }, 0)

    if (args.rotationStep) this.rotate(args.rotationStep, 0);
  }

  createLabel (args) {
    this.label = document.createElement("div");
    this.label.className = "label " + args.color;
    this.label.dataset.section = "section-2";
    this.label.dataset.state = "hidden";
    this.label.dataset.type = args.type;

    this.label.textContent = args.label;

    this.element.appendChild(this.label);
  }

  rotate (steps, duration = 0.5) {
    return gsap.to(this.rotation, { progress: steps * this.stepSize, duration, ease: "power1.inOut" })
  }
}